webpackJsonp([225902193080362],{

/***/ 1219:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"htmlAst":{"type":"root","children":[{"type":"element","tagName":"h2","properties":{},"children":[{"type":"text","value":"Uitleg"}]},{"type":"text","value":"\n"},{"type":"element","tagName":"p","properties":{},"children":[{"type":"text","value":"De vormen van het "},{"type":"element","tagName":"a","properties":{"href":"/spqr/rijtjes/vragend-voornaamwoord"},"children":[{"type":"text","value":"zelfstandig vragend voornaamwoord"}]},{"type":"text","value":" moet je uit je hoofd leren, ze zijn vrij onregelmatig."}]}],"data":{"quirksMode":false}},"frontmatter":{"book":"spqr","leerdoel":"22c","title":"Leerdoel 22c"}}},"pathContext":{"slug":"/spqr/leerdoelen/22c/","title":"Leerdoel 22c"}}

/***/ })

});


// WEBPACK FOOTER //
// path---spqr-leerdoelen-22-c-61c7cfc858026ab559ca.js